import React from "react";

import { Container, Row } from "../components";
import { useI18n } from "../lib/i18n/i18n_provider";
import { Content } from "./content";
import { Spacer } from "./spacer";
import { Text } from "./text";
import { assetUrl } from "../core/assets";

export function Footer(props: { displayAccessibility?: string }) {
  const { fbt } = useI18n();

  return (
    <div className="footer">
      <Content>
        <Container paddingHorizontal={16}>
          <Row alignItems="center" justifyContent="space-between">
            <Text color="muted">
              {fbt("Powered by")}{" "}
              <FooterLink href="https://flexspace.ai">
                Flexspace&reg;
              </FooterLink>
            </Text>
            <Row>
              <FooterLink href={assetUrl("documents/flexspace-privacy.pdf")}>
                {fbt("Privacy")}
              </FooterLink>
              <Spacer size={8} direction="horizontal" />
              <Text color="muted">·</Text>
              <Spacer size={8} direction="horizontal" />
              <FooterLink href={assetUrl("documents/flexspace-terms.pdf")}>
                {fbt("Terms")}
              </FooterLink>
              {props.displayAccessibility && (
                <>
                  <Spacer size={8} direction="horizontal" />
                  <Text color="muted">·</Text>
                  <Spacer size={8} direction="horizontal" />
                  <FooterLink href={props.displayAccessibility}>
                    {fbt("Accessibility")}
                  </FooterLink>
                </>
              )}
            </Row>
          </Row>
        </Container>
      </Content>
    </div>
  );
}

interface FooterLinkProps {
  href?: string;
  children: React.ReactText;
}

function FooterLink(props: FooterLinkProps) {
  const { href, children } = props;

  return (
    <a
      className="footer-link"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Text color="muted">{children}</Text>
    </a>
  );
}
